/**
 * Wire-format error codes for the Cognito auth boundary (ADR-0012).
 * Emitted by the backend `_auth` middleware as `error.code` on `403` responses
 * and matched verbatim by the frontend response classifier. Shared here so
 * both sides compare against one source of truth instead of duplicated literals.
 */
export enum AuthErrorCode {
	USER_NOT_PROVISIONED = 'USER_NOT_PROVISIONED',
	USER_INACTIVE = 'USER_INACTIVE',
	ACCESS_FORBIDDEN = 'ACCESS_FORBIDDEN',
}

/**
 * Rejection reasons for the `401` checks that precede a verified identity. These
 * are not Atlas authorization outcomes, so they carry no {@link AuthErrorCode} and
 * never reach the wire — they label the rejection in the auth log only.
 */
export enum AuthRejectionReason {
	MISSING_CREDENTIALS = 'missing_credentials',
	TOKEN_VERIFICATION_FAILED = 'token_verification_failed',
	/**
	 * A presented API key did not resolve to a usable one — deliberately one reason
	 * covering unknown, revoked, blocked, expired and idle, since the response is an
	 * identical 401 in every case.
	 */
	API_KEY_REJECTED = 'api_key_rejected',
	/** A key was presented to a route that accepts interactive sessions only. */
	API_KEY_NOT_ACCEPTED_HERE = 'api_key_not_accepted_here',
}

/** Actor kinds recorded on user-audit events (ADR-0013). */
export enum ActorType {
	ATLAS_USER = 'ATLAS_USER',
	AWS_OPERATOR = 'AWS_OPERATOR',
}
